module.exports = "mutation DeleteUnit($unitId:ID!){deleteUnit(unitId:$unitId){success}}"